import {Component, TemplateRef, ViewChild} from '@angular/core';
import {SubscribedComponent} from "../../subscribed.component";
import {DualAxisDelegate} from "../../dual-axis/dual-axis.component";
import {Client} from "../../interfaces/client";
import {TreeNode} from "../../interfaces/treenode";
import {ColDef, ColType} from "../../interfaces/colDef";
import {Paged} from "../../interfaces/paged";
import {ClientService} from "../../shared/client.service";
import {AuthService} from "../../shared/auth.service";
import {User} from "../../interfaces/user";
import {Router} from "@angular/router";
import {Globals} from "../../shared/Globals";

@Component({
    selector: 'bst-cur-client-selector',
    templateUrl: './cur-client-selector.component.html',
    styleUrls: ['./cur-client-selector.component.scss'],
    standalone: false
})
export class CurClientSelectorComponent extends SubscribedComponent implements DualAxisDelegate<Client>{

  user: User;

  constructor(private clientService: ClientService,
              private router: Router,
              private auth: AuthService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.subs.push(this.auth.user.subscribe((newuser) => {
      this.user = newuser;
    }));
  }

  @ViewChild('cellTemplate', {static: true, read: TemplateRef}) cellTemplateOutlet: TemplateRef<any>;
  data: TreeNode<Client>[] = []

  async paged(page: number): Promise<Paged<Client>> {
    this.loading.next(true);
    const directory = await this.auth.myCompanies(page).catch(() => null);
    this.loading.next(false);

    if(page <= 1){
      this.data = [];
    }

    if(directory && directory.data){
      this.data = this.data.concat(directory.data.map((o: Client) => {
        return {
          data: o,
          children: [],
          expanded: false
        };
      }));
      return directory;
    }
  }

  standardColumns: ColDef[] = [
    {
      name: 'name',
      title: 'name',
      required: true,
      sort: false,
      filter: false,
      type: ColType.STRING
    },
    {
      name: 'description',
      title: 'description',
      required: true,
      sort: false,
      filter: false,
      type: ColType.STRING
    },
    {
      name: 'active',
      title: 'activeprofile',
      required: true,
      sort: false,
      filter: false,
      type: ColType.BOOL,
      style: {
        textAlign: 'center'
      }
    },
    {
      name: 'status',
      title: 'status',
      required: true,
      sort: false,
      filter: false,
      type: ColType.INT,
      style: {
        textAlign: 'center'
      }
    },
    {
      name: 'start_on',
      title: 'startdate',
      required: true,
      sort: false,
      filter: false,
      type: ColType.DATE
    },
    {
      name: 'end_on',
      title: 'enddate',
      required: true,
      sort: false,
      filter: false,
      type: ColType.DATE
    }
  ];
  stickyColumnsLeft: ColDef[] = [];
  stickyColumnsRight: ColDef[] = [];

  selectClient(client: Client) {
    if(client.url){
      window.open(Globals.url(client.url), '_blank').focus();
    }
  }

  isCurClient(client: Client){
    return this.user && this.user.client.id === client.id;
  }

  async setClient(client: Client) {
    this.loading.next(true);
    const newme = await this.auth.switchCompany(client);
    if(newme){
      this.loading.next(false);
      await this.router.navigate(['/users/me']);
    }
  }
}
